import React, { useContext } from 'react';
import * as XLSX from 'xlsx';
import Header from '../../components/Header';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import {
  getMedias,
  searchOrderRequest,
  getAdvertisers,
  getAgencies,
  getOrderDataReport,
} from '../../api/Api';
import dateUtils from '../../utilities/dateUtils';
import { ProfileContext } from '../../contexts/ProfileContext';
import { useCallback } from 'react';
import BulmaPagination from '../../components/Pagination';
import { useToasts } from 'react-toast-notifications';
import '../../index.css';
import FromToDateInput from '../../components/inputs/FromToDateInput';
import OrderNumberInput from '../../components/inputs/OrderNumberInput';
import InputWithAutocomplete from '../../components/inputs/InputWithAutocomplete';
import { useLoadingContext } from '../../contexts/LoadingContext';
import { useOrdersDataContext } from '../../contexts/OrdersDataContext';

const RESULTSLIMITPERPAGE = process.env.REACT_APP_API_RESULTS_LIMIT || 10;

const HomePage = () => {
  const headers = ['N Órden', 'Vigencia', 'Agencia', 'Anunciante', 'Producto', 'N.O. Cliente'];
  //const headers = ['N Órden', 'Vigencia', 'Medio', 'Agencia', 'Anunciante', 'Producto', 'N.O. Cliente'];
  const [results, setResults] = useState([]);
  const { filter, setFilter, pagination, setPagination } = useOrdersDataContext();
  const [medias, setMedias] = useState([]);
  const [mediaSearchTerm, setMediaSearchTerm] = useState('');
  const [childMedias, setChildMedias] = useState([]);
  const [childMediaSearchTerm, setChildMediaSearchTerm] = useState('');
  const [advertisers, setAdvertisers] = useState([]);
  const [advertiserSearchTerm, setAdvertiserSearchTerm] = useState('');
  const [resultsFetched, setResultsFetched] = useState(false);
  const { setLoading } = useLoadingContext();
  const [toDate, setToDate] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [agencies, setAgencies] = useState([]);
  const [agencySearchTerm, setAgencySearchTerm] = useState('');
  const { profile, fetchProfileData, isLoadingProfile } = useContext(ProfileContext);
  const [badFromYear, setBadFromYear] = useState(false);
  const [badToYear, setBadToYear] = useState(false);
  const { addToast } = useToasts();

  const fetchAdvertisers = useCallback(() => {
    getAdvertisers()
      .then(({ json }) => {
        const advertisersArray = json.map((advertiser) => advertiser.name);
        setAdvertisers(advertisersArray);
      })
      .catch((error) => {
        console.log('advertisers', error);
      });
  }, []);

  const getOrderResponse = async (page = 1) => {
    setLoading(true);
    const { limit } = pagination;
    let offset;
    if (page === 1) {
      offset = 0;
    } else {
      offset = (page - 1) * limit;
    }

    const newFilters = { ...filter, ...pagination, offset };
    const resultsJson = await searchOrderRequest(newFilters);
    const { results, count } = resultsJson;
    const parsed = parseResults(results);
    setResults(parsed);

    const newPagination = pagination;
    newPagination.count = count;
    newPagination.currentPage = page;
    setPagination(newPagination);
    setLoading(false);
  };

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      fetchProfileData();
      const { json: mediasJson } = await getMedias('parentMediasOnly=True');
      const { json: agenciesJson } = await getAgencies();
      const { json: afiliadosJson } = await getMedias('childMediasOnly=True');
      setChildMedias(afiliadosJson.map((media) => media.name));
      setAgencies(agenciesJson.map((agency) => agency.name));
      const { currentPage } = pagination;
      await getOrderResponse(currentPage);
      const mediasSuggestions = mediasJson.map((media) => media.name);
      setMedias(mediasSuggestions);
      setResultsFetched(true);
      setLoading(false);
    };
    fetchAdvertisers();
    fetchOrders();
  }, []);

  useEffect(() => {
    const from = dateUtils.isValidDate(fromDate) ? fromDate : '';
    const to = dateUtils.isValidDate(toDate) ? toDate : '';
    setFilter({
      ...filter,
      media: mediaSearchTerm,
      fromDate: from,
      toDate: to,
      advertiser: advertiserSearchTerm,
      childMedia: childMediaSearchTerm,
      agency: agencySearchTerm,
    });
  }, [
    mediaSearchTerm,
    fromDate,
    toDate,
    advertiserSearchTerm,
    childMediaSearchTerm,
    agencySearchTerm,
  ]);

  /*   useEffect(() => {
    const reFetchOrders = async () => {
      const { currentPage } = pagination;
      await getOrderResponse(currentPage);
    };
    if (resultsFetched && !Object.entries(filter).find((key) => key[1])) {
      reFetchOrders();
    }
  }, [filter]); */

  useEffect(() => {
    if (mediaSearchTerm) {
      setChildMediaSearchTerm('');
      setChildMedias([]);
      getMedias(`parentMedia=${mediaSearchTerm}`).then(({ json }) => {
        if (json && json.length > 0) setChildMedias(json.map((afiliado) => afiliado.name));
      });
    }
  }, [mediaSearchTerm, medias]);

  const onClickPageNumber = async (pageNumber) => {
    setLoading(true);
    await getOrderResponse(pageNumber);
    setLoading(false);
  };

  const clearFilters = async () => {
    setFilter({
      year: '',
      month: '',
      orderNumber: '',
      media: '',
      fromDate: '',
      toDate: '',
      product: '',
      orderStatus: '',
      conciliateStatus: '',
      advertiser: '',
    });
    setPagination({
      count: 0,
      limit: RESULTSLIMITPERPAGE,
      currentPage: 1,
      offset: 0,
    });
    setMediaSearchTerm('');
    setToDate('');
    setFromDate('');
    setAdvertiserSearchTerm('');
    setChildMediaSearchTerm('');
    setAgencySearchTerm('');
  };

  const parseResults = (results) => {
    if (!results) return [];
    return results.map((result) => {
      const orderNumber = result.order_number;
      const vigencia = result.valid_until;
      return {
        'N Órden': orderNumber,
        Vigencia: vigencia,
        Agencia: result.agency?.name,
        Anunciante: result.advertiser?.name,
        Producto: result.product,
        'N.O. Cliente': result.client_order_number,
        ...result,
      };
    });
  };

  const handleOnChangeFilter = (event, field) => {
    const newValue = event.target.value;
    const newFilter = { ...filter, [field]: newValue };
    setFilter(newFilter);
  };

  const applyFilter = async () => {
    setLoading(true);

    if (new Date(filter.toDate) < new Date(filter.fromDate)) {
      addToast(
        'Fecha Vigencia Hasta no puede ser menor que Fecha Desde o el formato de fechas está incorrecto, por favor verifique.',
        {
          appearance: 'error',
          autoDismiss: true,
          autoDismissTimeout: 3000,
          placement: 'bottom-center',
        }
      );
      setLoading(false);
      return;
    }

    if (badFromYear || badToYear) {
      addToast(
        'Fecha Vigencia Hasta no puede ser menor que Fecha Desde o el formato de fechas está incorrecto, por favor verifique.',
        {
          appearance: 'error',
          autoDismiss: true,
          autoDismissTimeout: 3000,
          placement: 'bottom-center',
        }
      );
      setLoading(false);
      return;
    }

    await getOrderResponse();
    setResultsFetched(true);
    setLoading(false);
  };

  const excelReport = async () => {
    setLoading(true);
    const ordersToExport = results.map((result) => result.id);
    const body = {
      ordersToExport: ordersToExport,
    };
    const response = await getOrderDataReport(body);
    const data = await response.json();
    const rows = [
      [
        'Nro órden',
        'Agencia',
        'Anunciante',
        'Usuario',
        'Tel Usuario',
        'Medio',
        'Orden Vista',
        'Material Descargado',
        'Estado Op',
        'Estado Conciliacion',
        'H.P',
        'H.T',
        'C.T',
      ], // Encabezados de las columnas
      ...data.results.map((item) => [
        item.nro_orden,
        item.agencia,
        item.anunciante,
        item.usuario,
        item.telefono,
        item.medio,
        item.orden_vista,
        item.material_descargado,
        item.estado_op,
        item.estado_conciliacion,
        item.archivo_programado,
        item.archivo_transmitido,
        item.archivo_testigo,
      ]),
    ];
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(rows);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // tambien puede usarse 'array' en type:'buffer por si fallara'

    const blob = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });

    // Crea un enlace para la descarga automática
    const url = window.URL.createObjectURL(
      new Blob([blob], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
    );
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = 'Reporte Afiliados.xlsx';
    document.body.appendChild(a);
    a.click();

    // Libera los recursos utilizados por el Blob y el enlace
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    setLoading(false);
  };

  const handleChangeDate = (event, field) => {
    const { value } = event.target;

    const year = parseInt(value.slice(0, 4));
    if (field === 'from') {
      if (year < 1970) {
        setBadFromYear(true);
        setFromDate(value);
      } else {
        setBadFromYear(false);
        setFromDate(value);
      }
    } else {
      if (year < 1970) {
        setBadToYear(true);
        setToDate(value);
      } else {
        setBadToYear(false);
        setToDate(value);
      }
    }
  };

  const seenByUser = (result) => {
    const found = result.seen_by.find((user) => user.id === profile?.id);
    return found;
  };

  const Pagination = () => {
    const { currentPage, count, limit } = pagination;
    return (
      <section>
        <div className="columns is-centered">
          <div className="column is-half">
            <BulmaPagination
              pages={Math.ceil(count / limit)}
              currentPage={currentPage}
              onChange={(page) => onClickPageNumber(page)}
            />
          </div>
        </div>
      </section>
    );
  };

  // const Results = () => {
  //   return (
  //     <section className="section">
  //       <table id="results" className="table is-fullwidth is-hoverable has-text-centered ">
  //         <thead>
  //           <tr>
  //             {headers.map((header, index) => (
  //               <th key={index} title={header}>
  //                 {header}
  //               </th>
  //             ))}
  //             {/* <th>N Órden Cliente</th> */}
  //             {profile?.is_admin && <th>Procesado</th>}
  //             <th>Conciliacion</th>
  //             <th>Acciones</th>
  //             {!profile?.is_admin && <th>Procesado</th>}
  //             {profile?.is_admin && <th>Visto</th>}
  //           </tr>
  //         </thead>
  //         <tfoot>
  //           <tr>
  //             {headers.map((header, index) => (
  //               <th key={index} title={header}>
  //                 {header}
  //               </th>
  //             ))}
  //             {/* <th>N Órden Cliente</th> */}
  //             {profile?.is_admin && <th>Procesado</th>}
  //             <th>Conciliacion</th>
  //             <th>Acciones</th>
  //             {!profile?.is_admin && <th>Procesado</th>}
  //             {profile?.is_admin && <th>Visto</th>}
  //           </tr>
  //         </tfoot>
  //         <tbody>
  //           {results &&
  //             results.map((result) => {
  //               const seen = seenByUser(result);
  //               return (
  //                 <tr
  //                   key={result['N Órden']}
  //                   id={result['N Órden']}
  //                   className={`orderRow ${seen ? 'visto' : 'no-visto'}`}
  //                   style={{ background: result.conciliate_data.color }}
  //                 >
  //                   {headers
  //                     .filter((header) => header)
  //                     .map((header, index) => (
  //                       <td key={index}>{result[header]}</td>
  //                     ))}
  //                   {/* <td className="orderNumber">{result['client_order_number']}</td> */}
  //                   {profile?.is_admin && (
  //                     <td>
  //                       {`${result.process_data.total_processed}/${result.process_data.total}`}
  //                     </td>
  //                   )}
  //                   <td>
  //                     {`${result.conciliate_data.conciliate_data_number}/${result.conciliate_data.users_conciliate_number}`}
  //                   </td>
  //                   <td>
  //                     <Link to={`/portal/orden/${result['N Órden']}`}>Abrir</Link>
  //                   </td>
  //                   <td>
  //                     {seen && profile?.is_admin && (
  //                       <span className="icon">
  //                         <i className="fas fa-star"></i>
  //                       </span>
  //                     )}
  //                     {result.should_notify && !profile?.is_admin && (
  //                       <span className="icon">
  //                         <i className="fas fa-star"></i>
  //                       </span>
  //                     )}
  //                   </td>
  //                 </tr>
  //               );
  //             })}
  //         </tbody>
  //       </table>
  //       <Pagination />
  //     </section>
  //   );
  // };

  const Results = () => {
    return (
      <section className="section mt-5">
        <div className="table-container">
          <table
            id="results"
            className="table is-fullwidth is-hoverable has-text-centered is-striped"
          >
            <thead>
              <tr>
                {headers.map((header, index) => (
                  <th key={index} title={header} className="has-text-weight-bold">
                    {header}
                  </th>
                ))}
                {profile?.is_admin && <th className="has-text-weight-bold">Procesado</th>}
                <th className="has-text-weight-bold">Conciliación</th>
                <th className="has-text-weight-bold">Acciones</th>
                {!profile?.is_admin && <th className="has-text-weight-bold">Procesado</th>}
                {profile?.is_admin && <th className="has-text-weight-bold">Visto</th>}
              </tr>
            </thead>
            <tfoot>
              <tr>
                {headers.map((header, index) => (
                  <th key={index} title={header} className="has-text-weight-bold">
                    {header}
                  </th>
                ))}
                {profile?.is_admin && <th className="has-text-weight-bold">Procesado</th>}
                <th className="has-text-weight-bold">Conciliación</th>
                <th className="has-text-weight-bold">Acciones</th>
                {!profile?.is_admin && <th className="has-text-weight-bold">Procesado</th>}
                {profile?.is_admin && <th className="has-text-weight-bold">Visto</th>}
              </tr>
            </tfoot>
            <tbody>
              {results &&
                results.map((result) => {
                  const seen = seenByUser(result);
                  return (
                    <tr
                      key={result['N Órden']}
                      id={result['N Órden']}
                      className={`orderRow ${seen ? 'visto' : 'no-visto'} hover-row`}
                      style={{
                        background: result.conciliate_data.color,
                        transition: 'all 0.2s ease',
                      }}
                    >
                      {headers
                        .filter((header) => header)
                        .map((header, index) => (
                          <td key={index} className="is-vcentered">
                            <span className="has-text-weight-medium">{result[header]}</span>
                          </td>
                        ))}

                      {profile?.is_admin && (
                        <td className="is-vcentered">
                          <span className="tag is-info is-light size">
                            {`${result.process_data.total_processed}/${result.process_data.total}`}
                          </span>
                        </td>
                      )}

                      <td className="is-vcentered">
                        <span className="tag is-primary is-light size">
                          {`${result.conciliate_data.conciliate_data_number}/${result.conciliate_data.users_conciliate_number}`}
                        </span>
                      </td>

                      <td className="is-vcentered">
                        <Link
                          to={`/portal/orden/${result['N Órden']}`}
                          className="button is-primary is-small is-rounded has-text-weight-medium size"
                          style={{
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                          }}
                        >
                          <span className="icon is-small">
                            <i className="fa fa-eye"></i>
                          </span>
                          <span>Abrir</span>
                        </Link>
                      </td>

                      <td className="is-vcentered">
                        {seen && profile?.is_admin && (
                          <span
                            className="icon"
                            title="Visto por admin"
                            style={{ color: '#FFD700' }}
                          >
                            <i className="fa fa-star"></i>
                          </span>
                        )}
                        {result.should_notify && !profile?.is_admin && (
                          <span
                            className="icon"
                            title="Notificación pendiente"
                            style={{ color: '#FFD700' }}
                          >
                            <i className="fa fa-star"></i>
                          </span>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <Pagination />

        {/* Estilos CSS adicionales */}
        <style jsx>{`
          .hover-row:hover {
            background-color: rgba(0, 0, 0, 0.05) !important;
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          }

          .button.is-primary.is-small:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          }

          .table th {
            background-color: #f8f9fa;
            border-bottom: 2px solid #dee2e6;
            padding: 1rem 0.75rem;
          }

          .table td {
            padding: 1rem 0.75rem;
            vertical-align: middle;
          }

          .orderRow {
            border-left: 4px solid transparent;
          }

          .orderRow.visto {
            border-left-color: #48c78e;
          }

          .orderRow.no-visto {
            border-left-color: #ff7043;
          }

          .table-container {
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          }

          .tag {
            font-weight: 600;
          }

          .size {
            font-size: 0.9rem !important;
          }
        `}</style>
      </section>
    );
  };

  if (isLoadingProfile) {
    return <div>Cargando...</div>;
  }

  // return (
  //   <div>
  //     <Header />
  //     <section className="section">
  //       <div className="columns mb-0 pb-0">
  //         <OrderNumberInput
  //           filter={filter}
  //           onChangeYear={(event) => handleOnChangeFilter(event, 'year')}
  //           onChangeMonth={(event) => handleOnChangeFilter(event, 'month')}
  //           onChangeOrderNumber={(event) => handleOnChangeFilter(event, 'orderNumber')}
  //         />
  //         {profile?.is_admin && (
  //           <>
  //             <InputWithAutocomplete
  //               title="Medio Cabecera"
  //               suggestions={medias}
  //               searchTerm={mediaSearchTerm}
  //               setSeachTerm={setMediaSearchTerm}
  //             />
  //             <InputWithAutocomplete
  //               title="Medio Afiliado"
  //               suggestions={childMedias}
  //               searchTerm={childMediaSearchTerm}
  //               setSeachTerm={setChildMediaSearchTerm}
  //               disabled={mediaSearchTerm && childMedias.length === 0}
  //             />
  //           </>
  //         )}
  //         <div className={`${profile?.is_admin ? 'column' : 'column is-one-third'}`}>
  //           <h4 className="label" style={{ marginBottom: '0' }}>
  //             Estado Procesamiento OP
  //           </h4>
  //           <div className="columns mb-0 pb-0" style={{ paddingTop: '1rem' }}>
  //             <div className="column">
  //               <label className="radio mr-1">Todas</label>
  //               <input
  //                 type="radio"
  //                 name="orderStatus"
  //                 value="todas"
  //                 checked={filter.orderStatus === 'todas'}
  //                 onChange={(event) => handleOnChangeFilter(event, 'orderStatus')}
  //               />
  //             </div>
  //             <div className="column">
  //               <label className="radio mr-1">Pendientes</label>
  //               <input
  //                 type="radio"
  //                 name="orderStatus"
  //                 value="pendientes"
  //                 checked={filter.orderStatus === 'pendientes'}
  //                 onChange={(event) => handleOnChangeFilter(event, 'orderStatus')}
  //               />
  //             </div>
  //             <div className="column">
  //               <label className="radio mr-1"> Procesadas</label>
  //               <input
  //                 type="radio"
  //                 name="orderStatus"
  //                 value="procesadas"
  //                 checked={filter.orderStatus === 'procesadas'}
  //                 onChange={(event) => handleOnChangeFilter(event, 'orderStatus')}
  //               />
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //       <div className="columns mb-0 pb-0">
  //         <FromToDateInput
  //           title="Vigencia Órden"
  //           fromDate={fromDate}
  //           toDate={toDate}
  //           onChangeFrom={(event) => handleChangeDate(event, 'from')}
  //           onChangeTo={(event) => handleChangeDate(event, 'to')}
  //         />
  //         <InputWithAutocomplete
  //           title="Agencia"
  //           suggestions={agencies}
  //           searchTerm={agencySearchTerm}
  //           setSeachTerm={setAgencySearchTerm}
  //         />
  //         <InputWithAutocomplete
  //           title="Anunciante"
  //           suggestions={advertisers}
  //           searchTerm={advertiserSearchTerm}
  //           setSeachTerm={setAdvertiserSearchTerm}
  //         />
  //         <div className="column">
  //           <h4 className="label" style={{ marginBottom: '0' }}>
  //             Estado Conciliacion OP
  //           </h4>
  //           <div className="columns mb-0 pb-0" style={{ paddingTop: '1rem' }}>
  //             <div className="column">
  //               <label className="radio mr-1">Todas</label>
  //               <input
  //                 type="radio"
  //                 name="conciliateStatus"
  //                 value="todas"
  //                 checked={filter.conciliateStatus === 'todas'}
  //                 onChange={(event) => handleOnChangeFilter(event, 'conciliateStatus')}
  //               />
  //             </div>
  //             <div className="column">
  //               <label className="radio mr-1">Completos</label>
  //               <input
  //                 type="radio"
  //                 name="conciliateStatus"
  //                 value="completos"
  //                 checked={filter.conciliateStatus === 'completos'}
  //                 onChange={(event) => handleOnChangeFilter(event, 'conciliateStatus')}
  //               />
  //             </div>
  //             <div className="column">
  //               <label className="radio mr-1"> Faltantes</label>
  //               <input
  //                 type="radio"
  //                 name="conciliateStatus"
  //                 value="faltantes"
  //                 checked={filter.conciliateStatus === 'faltantes'}
  //                 onChange={(event) => handleOnChangeFilter(event, 'conciliateStatus')}
  //               />
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //       <div className="container is-pulled-right">
  //         <button className="button is-dark mr-4" onClick={applyFilter}>
  //           Consultar &nbsp;
  //           <i className="fa fa-search" aria-hidden="true"></i>
  //         </button>
  //         <button className="button is-primary mr-4" onClick={() => clearFilters()}>
  //           Limpiar filtros &nbsp;
  //           <i className="fa fa-times-circle" aria-hidden="true"></i>
  //         </button>
  //         {profile?.is_admin && (
  //           <button className="button is-warning" onClick={excelReport}>
  //             Generar Reporte &nbsp;
  //             <i className="fa fa-file-excel-o" aria-hidden="true"></i>
  //           </button>
  //         )}
  //       </div>
  //       <Results />
  //     </section>
  //   </div>
  // );

  return (
    <div>
      <Header />
      <section className="section">
        {/* ✅ NUEVA SECCIÓN DE FILTROS MEJORADA */}
        <div
          className="box"
          style={{
            margin: '1rem 0',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            padding: '1.5rem',
          }}
        >
          <div className="content">
            {/* Primera fila de filtros */}
            <div className="columns is-multiline mb-2" style={{ marginBottom: '1rem' }}>
              <div className="column is-3">
                <div className="field">
                  <OrderNumberInput
                    filter={filter}
                    onChangeYear={(event) => handleOnChangeFilter(event, 'year')}
                    onChangeMonth={(event) => handleOnChangeFilter(event, 'month')}
                    onChangeOrderNumber={(event) => handleOnChangeFilter(event, 'orderNumber')}
                    margin="is-10"
                  />
                </div>
              </div>


              <div className="column is-3">
                <div className="field">
                  <FromToDateInput
                    title="Vigencia Orden"
                    fromDate={fromDate}
                    toDate={toDate}
                    onChangeFrom={(event) => handleChangeDate(event, 'from')}
                    onChangeTo={(event) => handleChangeDate(event, 'to')}
                  />
                </div>
              </div>

              <div className="column is-2-and-half">
                <div className="field">
                  <InputWithAutocomplete
                    title="Agencia"
                    suggestions={agencies}
                    searchTerm={agencySearchTerm}
                    setSeachTerm={setAgencySearchTerm}
                  />
                </div>
              </div>

              {/* Para afiliados: Anunciante aquí */}
              {!profile?.is_admin && (
                <div className="column is-2-and-half">
                  <div className="field">
                    <InputWithAutocomplete
                      title="Anunciante"
                      suggestions={advertisers}
                      searchTerm={advertiserSearchTerm}
                      setSeachTerm={setAdvertiserSearchTerm}
                    />
                  </div>
                </div>
              )}
            </div>

            {/* Segunda fila - Admin: Anunciante + Medios | Afiliado: Solo Estados */}
            {profile?.is_admin ? (
              // Vista Admin: Segunda fila con Anunciante + Medios
              <div className="columns mb-2" style={{ marginBottom: '1rem' }}>
                <div className="column is-3">
                  <div className="field">
                    <InputWithAutocomplete
                      title="Anunciante"
                      suggestions={advertisers}
                      searchTerm={advertiserSearchTerm}
                      setSeachTerm={setAdvertiserSearchTerm}
                    />
                  </div>
                </div>

                <div className="column is-3">
                  <div className="field">
                    <InputWithAutocomplete
                      title="Medio Cabecera"
                      suggestions={medias}
                      searchTerm={mediaSearchTerm}
                      setSeachTerm={setMediaSearchTerm}
                    />
                  </div>
                </div>

                <div className="column is-3">
                  <div className="field">
                    <InputWithAutocomplete
                      title="Medio Afiliado"
                      suggestions={childMedias}
                      searchTerm={childMediaSearchTerm}
                      setSeachTerm={setChildMediaSearchTerm}
                      disabled={mediaSearchTerm && childMedias.length === 0}
                    />
                  </div>
                </div>
              </div>
            ) : (
              // Vista Afiliado: Segunda fila con Estados
              <div className="columns mb-2" style={{ marginBottom: '1rem' }}>
                <div className="column is-6">
                  <div
                    className="card"
                    style={{ borderRadius: '8px', border: '1px solid #e8e8e8' }}
                  >
                    <div className="card-content" style={{ padding: '1rem' }}>
                      <h6 className="subtitle is-6 has-text-weight-semibold mb-3 has-text-info">
                        <span className="icon-text">
                          <span className="icon">
                            <i className="fa fa-tasks"></i>
                          </span>
                          <span>Estado Procesamiento OP</span>
                        </span>
                      </h6>
                      <div className="field is-grouped is-grouped-multiline">
                        <div className="control">
                          <label className="radio has-text-weight-medium">
                            <input
                              type="radio"
                              name="orderStatus"
                              value="todas"
                              checked={filter.orderStatus === 'todas'}
                              onChange={(event) => handleOnChangeFilter(event, 'orderStatus')}
                              style={{ marginRight: '8px' }}
                            />
                            <span className="tag is-light is-info is-size-6">Todas</span>
                          </label>
                        </div>
                        <div className="control">
                          <label className="radio has-text-weight-medium">
                            <input
                              type="radio"
                              name="orderStatus"
                              value="pendientes"
                              checked={filter.orderStatus === 'pendientes'}
                              onChange={(event) => handleOnChangeFilter(event, 'orderStatus')}
                              style={{ marginRight: '8px' }}
                            />
                            <span className="tag is-light is-warning is-size-6">Pendientes</span>
                          </label>
                        </div>
                        <div className="control">
                          <label className="radio has-text-weight-medium">
                            <input
                              type="radio"
                              name="orderStatus"
                              value="procesadas"
                              checked={filter.orderStatus === 'procesadas'}
                              onChange={(event) => handleOnChangeFilter(event, 'orderStatus')}
                              style={{ marginRight: '8px' }}
                            />
                            <span className="tag is-light is-success is-size-6">Procesadas</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="column is-6">
                  <div
                    className="card"
                    style={{ borderRadius: '8px', border: '1px solid #e8e8e8' }}
                  >
                    <div className="card-content" style={{ padding: '1rem' }}>
                      <h6 className="subtitle is-6 has-text-weight-semibold mb-3 has-text-primary">
                        <span className="icon-text">
                          <span className="icon">
                            <i className="fa fa-check-circle"></i>
                          </span>
                          <span>Estado Conciliación OP</span>
                        </span>
                      </h6>
                      <div className="field is-grouped is-grouped-multiline">
                        <div className="control">
                          <label className="radio has-text-weight-medium">
                            <input
                              type="radio"
                              name="conciliateStatus"
                              value="todas"
                              checked={filter.conciliateStatus === 'todas'}
                              onChange={(event) => handleOnChangeFilter(event, 'conciliateStatus')}
                              style={{ marginRight: '8px' }}
                            />
                            <span className="tag is-light is-info is-size-6">Todas</span>
                          </label>
                        </div>
                        <div className="control">
                          <label className="radio has-text-weight-medium">
                            <input
                              type="radio"
                              name="conciliateStatus"
                              value="completos"
                              checked={filter.conciliateStatus === 'completos'}
                              onChange={(event) => handleOnChangeFilter(event, 'conciliateStatus')}
                              style={{ marginRight: '8px' }}
                            />
                            <span className="tag is-light is-success is-size-6">Completos</span>
                          </label>
                        </div>
                        <div className="control">
                          <label className="radio has-text-weight-medium">
                            <input
                              type="radio"
                              name="conciliateStatus"
                              value="faltantes"
                              checked={filter.conciliateStatus === 'faltantes'}
                              onChange={(event) => handleOnChangeFilter(event, 'conciliateStatus')}
                              style={{ marginRight: '8px' }}
                            />
                            <span className="tag is-light is-danger is-size-6">Faltantes</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Tercera fila - Solo para Admin: Estados */}
            {profile?.is_admin && (
              <div className="columns" style={{ marginBottom: '1rem' }}>
                <div className="column is-6">
                  <div
                    className="card"
                    style={{ borderRadius: '8px', border: '1px solid #e8e8e8' }}
                  >
                    <div className="card-content" style={{ padding: '1rem' }}>
                      <h6 className="subtitle is-6 has-text-weight-semibold mb-3 has-text-info">
                        <span className="icon-text">
                          <span className="icon">
                            <i className="fa fa-tasks"></i>
                          </span>
                          <span>Estado Procesamiento OP</span>
                        </span>
                      </h6>
                      <div className="field is-grouped is-grouped-multiline">
                        <div className="control">
                          <label className="radio has-text-weight-medium">
                            <input
                              type="radio"
                              name="orderStatus"
                              value="todas"
                              checked={filter.orderStatus === 'todas'}
                              onChange={(event) => handleOnChangeFilter(event, 'orderStatus')}
                              style={{ marginRight: '8px' }}
                            />
                            <span className="tag is-light is-info is-size-6">Todas</span>
                          </label>
                        </div>
                        <div className="control">
                          <label className="radio has-text-weight-medium">
                            <input
                              type="radio"
                              name="orderStatus"
                              value="pendientes"
                              checked={filter.orderStatus === 'pendientes'}
                              onChange={(event) => handleOnChangeFilter(event, 'orderStatus')}
                              style={{ marginRight: '8px' }}
                            />
                            <span className="tag is-light is-warning is-size-6">Pendientes</span>
                          </label>
                        </div>
                        <div className="control">
                          <label className="radio has-text-weight-medium">
                            <input
                              type="radio"
                              name="orderStatus"
                              value="procesadas"
                              checked={filter.orderStatus === 'procesadas'}
                              onChange={(event) => handleOnChangeFilter(event, 'orderStatus')}
                              style={{ marginRight: '8px' }}
                            />
                            <span className="tag is-light is-success is-size-6">Procesadas</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="column is-6">
                  <div
                    className="card"
                    style={{ borderRadius: '8px', border: '1px solid #e8e8e8' }}
                  >
                    <div className="card-content" style={{ padding: '1rem' }}>
                      <h6 className="subtitle is-6 has-text-weight-semibold mb-3 has-text-primary">
                        <span className="icon-text">
                          <span className="icon">
                            <i className="fa fa-check-circle"></i>
                          </span>
                          <span>Estado Conciliación OP</span>
                        </span>
                      </h6>
                      <div className="field is-grouped is-grouped-multiline">
                        <div className="control">
                          <label className="radio has-text-weight-medium">
                            <input
                              type="radio"
                              name="conciliateStatus"
                              value="todas"
                              checked={filter.conciliateStatus === 'todas'}
                              onChange={(event) => handleOnChangeFilter(event, 'conciliateStatus')}
                              style={{ marginRight: '8px' }}
                            />
                            <span className="tag is-light is-info is-size-6">Todas</span>
                          </label>
                        </div>
                        <div className="control">
                          <label className="radio has-text-weight-medium">
                            <input
                              type="radio"
                              name="conciliateStatus"
                              value="completos"
                              checked={filter.conciliateStatus === 'completos'}
                              onChange={(event) => handleOnChangeFilter(event, 'conciliateStatus')}
                              style={{ marginRight: '8px' }}
                            />
                            <span className="tag is-light is-success is-size-6">Completos</span>
                          </label>
                        </div>
                        <div className="control">
                          <label className="radio has-text-weight-medium">
                            <input
                              type="radio"
                              name="conciliateStatus"
                              value="faltantes"
                              checked={filter.conciliateStatus === 'faltantes'}
                              onChange={(event) => handleOnChangeFilter(event, 'conciliateStatus')}
                              style={{ marginRight: '8px' }}
                            />
                            <span className="tag is-light is-danger is-size-6">Faltantes</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Botones de acción mejorados */}
            <div className="has-text-right" style={{ marginTop: '1rem' }}>
              <div className="field is-grouped is-grouped-right">
                <div className="control">
                  <button
                    className="button is-light is-normal"
                    onClick={() => clearFilters()}
                    style={{
                      borderRadius: '8px',
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <span className="icon">
                      <i className="fa fa-times-circle"></i>
                    </span>
                    <span>Limpiar filtros</span>
                  </button>
                </div>
                <div className="control">
                  <button
                    className="button is-primary is-normal"
                    onClick={applyFilter}
                    style={{
                      borderRadius: '8px',
                      transition: 'all 0.2s ease',
                      boxShadow: '0 2px 8px rgba(0, 123, 255, 0.3)',
                    }}
                  >
                    <span className="icon">
                      <i className="fa fa-search"></i>
                    </span>
                    <span>Consultar</span>
                  </button>
                </div>
                {profile?.is_admin && (
                  <div className="control">
                    <button
                      className="button is-warning is-normal"
                      onClick={excelReport}
                      style={{
                        borderRadius: '8px',
                        transition: 'all 0.2s ease',
                      }}
                    >
                      <span className="icon">
                        <i className="fa fa-file-excel-o"></i>
                      </span>
                      <span>Generar Reporte</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* CSS adicional para mejorar la experiencia */}
          <style jsx>{`
            .card:hover {
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
              transition: all 0.2s ease;
            }

            .button:hover {
              transform: translateY(-1px);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            }

            .radio input[type='radio'] {
              transform: scale(1.1);
            }

            .tag {
              border-radius: 20px;
              font-weight: 600;
            }

            .field .label {
              color: #4a4a4a;
              font-size: 0.9rem;
            }

            .columns {
              margin-bottom: 0.5rem !important;
            }

            .column {
              padding: 0.5rem !important;
            }

            /* Columnas personalizadas para mejor distribución */
            .column.is-2-and-half {
              flex: none;
              width: 22.5%;
            }

            @media screen and (max-width: 768px) {
              .columns {
                margin: 0 !important;
              }

              .column {
                padding: 0.4rem !important;
              }

              .field.is-grouped.is-grouped-right {
                justify-content: center;
              }

              .column.is-2-and-half {
                width: 100%;
              }
            }
          `}</style>
        </div>

        {/* ✅ MANTENER: Tabla de resultados existente */}
        <Results />
      </section>
    </div>
  );
};

export default HomePage;
